<template>
  <el-table-column
    prop="responsible_user.last_name"
    sortable="custom"
    label="Felelős"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.responsible_user">{{ scope.row.responsible_user.last_name }} {{ scope.row.responsible_user.first_name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'responsible_user.last_name',
  };
</script>
